import type { Location } from 'history' 

export const getOnlyURLParams = (location: Location): string => {
  const query = new URLSearchParams(location.search)
  const urlRemove = ['code', 'session_state', 'code_challenge']

  for (const urlParam of urlRemove) {
    query.delete(urlParam)
  }
  
  return query.toString()
}